export const FinancialsKpisActionTypes = {
    API_RESPONSE_SUCCESS: '@@shipment-financials-analytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@financials-kpis/API_RESPONSE_ERROR',
    GET_CHARGES: '@@financials-kpis/GET_CHARGES',
    GET_ADJUSTMENTS: '@@financials-kpis/GET_ADJUSTMENTS',
    GET_ADJUSTMENTS_REPORT: '@@financials-kpis/GET_ADJUSTMENTS_REPORT',
    GET_CUSTOM_ADJUSTMENTS: '@@financials-kpis/GET_CUSTOM_ADJUSTMENTS',
    GET_CUSTOM_ADJUSTMENTS_REPORT: '@@financials-kpis/GET_CUSTOM_ADJUSTMENTS_REPORT',
    GET_MARGINS: '@@financials-kpis/GET_MARGINS',
    GET_MARGINS_REPORT: '@@financials-kpis/GET_MARGINS_REPORT',
    GET_VERIFIED_MARGINS: '@@financials-kpis/GET_VERIFIED_MARGINS',
    GET_VERIFIED_MARGINS_REPORT: '@@financials-kpis/GET_VERIFIED_MARGINS_REPORT',
    RESET_STATE: '@@financials-kpis/RESET_STATE',
};
